"use client";

import ListingFilterSelect from "@/app/components/filters/listing-filter-select";
import ListingSearchInput from "@/app/components/filters/listing-search-input";
import { usePostsFilterStore } from "@/app/stores/posts-filter-store";
import { useState, useEffect, useCallback } from "react";
import { getAllPostCategories } from "@/app/services/client/get-all-post-categories";
import type { PostCategoryT } from "@/app/types/posts";

export default function BlogPostsFilter() {
  const { selectedCategory, searchQuery, setSelectedCategory, setSearchQuery } =
    usePostsFilterStore();

  const [categories, setCategories] = useState<PostCategoryT[]>([]);
  const [isLoadingCategories, setIsLoadingCategories] = useState(false);
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const categoryOptions = [
    { value: "all", label: "Alle Kategorien" },
    ...categories.map((category) => ({
      value: category.key,
      label: category.label,
    })),
  ];

  // Load categories function
  const loadCategories = useCallback(async () => {
    if (categories.length > 0 || isLoadingCategories) return;

    setIsLoadingCategories(true);
    try {
      const fetchedCategories = await getAllPostCategories();
      setCategories(fetchedCategories || []);
    } catch (error) {
      console.error("Fehler beim Laden der Kategorien:", error);
    } finally {
      setIsLoadingCategories(false);
    }
  }, [categories.length, isLoadingCategories]);

  // Lazy load categories when select is opened
  useEffect(() => {
    if (isSelectOpen) {
      loadCategories();
    }
  }, [isSelectOpen, loadCategories]);

  return (
    <div className="mt-6 flex gap-4">
      <ListingFilterSelect
        value={selectedCategory}
        onValueChange={setSelectedCategory}
        onOpenChange={setIsSelectOpen}
        onMouseEnter={loadCategories}
        placeholder="Kategorie"
        label="Kategorie"
        options={categoryOptions}
        isLoading={isLoadingCategories}
      />
      <ListingSearchInput value={searchQuery} onChange={setSearchQuery} />
    </div>
  );
}
